// import { useState, useRef, useEffect } from 'react';
// import { uploadImage, submitConsignment } from '../lib/api';

// const BASE = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';

// const imgSrc = (url) => {
//   if (!url) return null;
//   if (url.startsWith('http')) return url;
//   return 'http://localhost' + url;
// };

// function useIsMobile(breakpoint = 768) {
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
//   );
//   useEffect(() => {
//     const handler = () => setIsMobile(window.innerWidth < breakpoint);
//     window.addEventListener('resize', handler);
//     return () => window.removeEventListener('resize', handler);
//   }, [breakpoint]);
//   return isMobile;
// }

// export default function SellPage() {
//   const isMobile = useIsMobile();

//   const [form, setForm] = useState({
//     name: '', phone: '', email: '',
//     brand: '', item: '', condition: 'Excellent',
//     asking_price: '', address: '', description: '',
//   });
//   const [images, setImages]       = useState([]);
//   const [uploading, setUploading] = useState(false);
//   const [saving, setSaving]       = useState(false);
//   const [success, setSuccess]     = useState(false);
//   const [error, setError]         = useState('');
//   const fileRef = useRef();

//   function onChange(e) {
//     setForm(f => ({ ...f, [e.target.name]: e.target.value }));
//   }

//   async function handleImages(e) {
//     const files = Array.from(e.target.files || []);
//     const remaining = 6 - images.length;
//     const toUpload  = files.slice(0, remaining);
//     if (!toUpload.length) return;

//     setUploading(true);
//     try {
//       const results = await Promise.all(
//         toUpload.map(async (file) => {
//           const preview = URL.createObjectURL(file);
//           const res     = await uploadImage(file);
//           const url     = res.url || res.path || res.file;
//           return { preview, url };
//         })
//       );
//       setImages(prev => [...prev, ...results]);
//     } catch (err) {
//       setError('Image upload failed. Please try again.');
//     } finally {
//       setUploading(false);
//       e.target.value = '';
//     }
//   }

//   function removeImage(i) {
//     setImages(prev => prev.filter((_, idx) => idx !== i));
//   }

//   async function handleSubmit(e) {
//     e.preventDefault();
//     setError('');
//     if (!form.name || !form.phone || !form.brand || !form.item) {
//       setError('Please fill in Name, Phone, Brand and Item.');
//       return;
//     }
//     if (images.length === 0) {
//       setError('Please upload at least one photo of your item.');
//       return;
//     }
//     setSaving(true);
//     try {
//       const imageUrls = images.map(i => i.url).join(',');
//       await submitConsignment({
//         name:         form.name,
//         phone:        form.phone,
//         email:        form.email,
//         brand:        form.brand,
//         model:        form.item,
//         condition:    form.condition,
//         asking_price: form.asking_price ? Number(form.asking_price) : null,
//         notes: [form.description, form.address ? `Address: ${form.address}` : ''].filter(Boolean).join('\n'),
//         images: imageUrls,
//       });
//       setSuccess(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       setError('Something went wrong. Please try again.');
//     } finally {
//       setSaving(false);
//     }
//   }

//   /* ── SUCCESS STATE ── */
//   if (success) return (
//     <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F8F5F0', padding: isMobile ? '40px 20px' : 40 }}>
//       <div style={{ textAlign: 'center', maxWidth: 480 }}>
//         <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#dcfce7', border: '2px solid #86efac', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
//           <svg width={32} height={32} fill="none" stroke="#16a34a" strokeWidth={2} viewBox="0 0 24 24">
//             <polyline points="20,6 9,17 4,12"/>
//           </svg>
//         </div>
//         <div style={{ fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 600, fontFamily: 'var(--font-body)', marginBottom: 14 }}>
//           Request Received
//         </div>
//         <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px,4vw,40px)', fontWeight: 300, color: 'var(--dark)', letterSpacing: '-0.01em', margin: '0 0 16px' }}>
//           Thank You
//         </h2>
//         <p style={{ fontSize: 14, color: 'var(--grey-mid)', lineHeight: 1.75, fontWeight: 300, marginBottom: 32 }}>
//           We've received your consignment request. Our team will review your submission and contact you within 24–48 hours with a valuation.
//         </p>
//         <button
//           onClick={() => { setSuccess(false); setForm({ name:'',phone:'',email:'',brand:'',item:'',condition:'Excellent',asking_price:'',address:'',description:'' }); setImages([]); }}
//           style={{ padding: '14px 40px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', fontWeight: 600, fontFamily: 'var(--font-body)', transition: 'background 0.25s', width: isMobile ? '100%' : 'auto' }}
//           onMouseEnter={e => e.currentTarget.style.background = 'var(--gold)'}
//           onMouseLeave={e => e.currentTarget.style.background = 'var(--dark)'}>
//           Submit Another
//         </button>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{ background: '#F8F5F0', minHeight: '100vh' }}>

//       {/* ── HERO BANNER ── */}
//       <section style={{
//         background: 'var(--dark)',
//         padding: isMobile ? '52px 20px 44px' : '72px 40px 60px',
//         textAlign: 'center',
//         position: 'relative',
//         overflow: 'hidden',
//       }}>
//         <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: 1, height: 40, background: 'var(--gold)', opacity: 0.6 }} />
//         <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: 1, height: 40, background: 'var(--gold)', opacity: 0.6 }} />
//         <div style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 600, fontFamily: 'var(--font-body)', marginBottom: 20 }}>
//           Consignment Service
//         </div>
        // <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(32px,6vw,64px)', fontWeight: 300, color: '#fff', letterSpacing: '-0.02em', lineHeight: 1.08, margin: '0 0 18px' }}>
        //   Sell Your Piece
        // </h1>
//         <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', lineHeight: 1.8, maxWidth: 480, margin: '0 auto', fontWeight: 300, fontFamily: 'var(--font-body)' }}>
//           We authenticate, value and sell your luxury items on your behalf — with full transparency and white-glove care at every step.
//         </p>
//       </section>

//       {/* ── HOW IT WORKS ── */}
      // <section style={{ background: '#fff', borderBottom: '1px solid #ede9e3', padding: isMobile ? '32px 16px' : '48px 40px' }}>
      //   <div style={{
      //     maxWidth: 900,
      //     margin: '0 auto',
      //     display: 'grid',
      //     gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)',
      //     gap: 0,
      //   }}>
      //     {[
      //       { n: '01', title: 'Submit Photos', desc: 'Upload clear images of your item from multiple angles.' },
      //       { n: '02', title: 'We Evaluate',   desc: 'Our experts authenticate and provide a fair market valuation.' },
      //       { n: '03', title: 'We Sell',        desc: 'Once listed, we handle photography, sales, and shipping.' },
      //     ].map((step, i) => (
      //       <div key={step.n} style={{
      //         padding: isMobile ? '20px 0' : '28px 36px',
      //         borderRight: !isMobile && i < 2 ? '1px solid #ede9e3' : 'none',
      //         borderBottom: isMobile && i < 2 ? '1px solid #ede9e3' : 'none',
      //       }}>
      //         <div style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 300, color: 'var(--gold)', lineHeight: 1, marginBottom: 12, opacity: 0.6 }}>{step.n}</div>
      //         <div style={{ fontSize: 12, letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 600, color: 'var(--dark)', fontFamily: 'var(--font-body)', marginBottom: 8 }}>{step.title}</div>
      //         <div style={{ fontSize: 12, color: 'var(--grey-mid)', lineHeight: 1.7 }}>{step.desc}</div>
      //       </div>
      //     ))}
      //   </div>
      // </section>

//       {/* ── FORM ── */}
//       <section style={{ padding: isMobile ? '32px 16px 48px' : '72px 40px', maxWidth: 1100, margin: '0 auto' }}>

//         {error && (
//           <div style={{ maxWidth: 760, margin: '0 auto 28px', padding: '14px 20px', background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontSize: 13 }}>
//             {error}
//           </div>
//         )}

//         <form onSubmit={handleSubmit}>
//           {/* On mobile: single column (images → item details → contact → notes → submit) */}
//           {/* On desktop: two column grid */}
//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//             gap: isMobile ? 16 : 28,
//           }}>

//             {/* ── LEFT col: Images + Notes ── */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 16 : 20 }}>

//               {/* Photos */}
//               <div style={{ background: '#fff', border: '1px solid #e8e4de', padding: isMobile ? 20 : 28 }}>
//                 <h3 style={sectionTitle}>Item Photos <span style={{ color: 'var(--red)', fontFamily: 'var(--font-body)' }}>*</span></h3>
//                 <p style={{ fontSize: 12, color: 'var(--grey-mid)', marginBottom: 20, lineHeight: 1.6 }}>
//                   Upload up to 6 photos. Include front, back, interior, hardware, and any serial number tags.
//                 </p>

//                 {/* Upload zone */}
//                 <div
//                   onClick={() => fileRef.current?.click()}
//                   style={{
//                     border: '2px dashed #d1c5b8',
//                     padding: isMobile ? '24px 16px' : '32px 20px',
//                     textAlign: 'center',
//                     cursor: 'pointer',
//                     marginBottom: 16,
//                     background: '#faf8f5',
//                     transition: 'border-color 0.2s, background 0.2s',
//                     minHeight: isMobile ? 100 : 130,
//                     display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10,
//                   }}
//                   onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--dark)'; e.currentTarget.style.background = '#f3f0eb'; }}
//                   onMouseLeave={e => { e.currentTarget.style.borderColor = '#d1c5b8'; e.currentTarget.style.background = '#faf8f5'; }}>
//                   <svg width={28} height={28} fill="none" stroke="var(--grey-mid)" strokeWidth={1.4} viewBox="0 0 24 24">
//                     <rect x="3" y="3" width="18" height="18" rx="2"/>
//                     <circle cx="8.5" cy="8.5" r="1.5"/>
//                     <polyline points="21,15 16,10 5,21"/>
//                   </svg>
//                   <div>
//                     <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--dark)', fontFamily: 'var(--font-body)', marginBottom: 4 }}>
//                       {uploading ? 'Uploading…' : 'Tap to upload photos'}
//                     </div>
//                     <div style={{ fontSize: 11, color: 'var(--grey-mid)' }}>
//                       JPG or PNG · Up to 6 photos · {images.length}/6 uploaded
//                     </div>
//                   </div>
//                 </div>
//                 <input ref={fileRef} type="file" accept="image/*" multiple hidden onChange={handleImages} />

//                 {/* Image grid */}
//                 {images.length > 0 && (
//                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
//                     {images.map((img, i) => (
//                       <div key={i} style={{ position: 'relative', aspectRatio: '1', overflow: 'hidden', background: '#e8e4de' }}>
//                         <img src={img.preview || imgSrc(img.url)} alt={`Upload ${i+1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
//                         <button
//                           type="button"
//                           onClick={() => removeImage(i)}
//                           style={{ position: 'absolute', top: 4, right: 4, width: 22, height: 22, borderRadius: '50%', background: 'rgba(0,0,0,0.7)', border: 'none', cursor: 'pointer', color: '#fff', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>
//                           ×
//                         </button>
//                         {i === 0 && (
//                           <div style={{ position: 'absolute', bottom: 4, left: 4, fontSize: 9, background: 'var(--gold)', color: '#fff', padding: '2px 6px', letterSpacing: '0.1em', fontWeight: 700 }}>
//                             MAIN
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                     {images.length < 6 && (
//                       <div
//                         onClick={() => fileRef.current?.click()}
//                         style={{ aspectRatio: '1', border: '2px dashed #d1c5b8', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 24, color: 'var(--grey-mid)', transition: 'border-color 0.2s', background: '#faf8f5' }}
//                         onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--dark)'}
//                         onMouseLeave={e => e.currentTarget.style.borderColor = '#d1c5b8'}>
//                         +
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* Notes — only shown in left col on desktop; shown inline on mobile after contact */}
//               {!isMobile && (
//                 <div style={{ background: '#fff', border: '1px solid #e8e4de', padding: 28 }}>
//                   <h3 style={sectionTitle}>Additional Notes</h3>
//                   <textarea
//                     name="description"
//                     value={form.description}
//                     onChange={onChange}
//                     rows={5}
//                     placeholder="Describe the item's history, any signs of wear, accessories included (dust bag, box, cards, receipt), year of purchase, etc."
//                     style={{ ...inputStyle, resize: 'vertical' }}
//                     onFocus={e => e.target.style.borderColor = 'var(--dark)'}
//                     onBlur={e  => e.target.style.borderColor = '#e5e7eb'}
//                   />
//                 </div>
//               )}
//             </div>

//             {/* ── RIGHT col: Item Details + Contact + Submit ── */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 16 : 20 }}>

//               {/* Item Details */}
//               <div style={{ background: '#fff', border: '1px solid #e8e4de', padding: isMobile ? 20 : 28 }}>
//                 <h3 style={sectionTitle}>Item Details</h3>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

//                   <Field label="Brand *" name="brand" value={form.brand} onChange={onChange}
//                     placeholder="e.g. Louis Vuitton, Chanel, Hermès" />

//                   <Field label="Item / Model *" name="item" value={form.item} onChange={onChange}
//                     placeholder="e.g. Neverfull MM, Classic Flap, Birkin 30" />

//                   <div>
//                     <label style={labelStyle}>Condition</label>
//                     <div style={{ position: 'relative' }}>
//                       <select name="condition" value={form.condition} onChange={onChange}
//                         style={{ ...inputStyle, cursor: 'pointer', appearance: 'none', paddingRight: 36 }}
//                         onFocus={e => e.target.style.borderColor = 'var(--dark)'}
//                         onBlur={e  => e.target.style.borderColor = '#e5e7eb'}>
//                         {['New with tags', 'New without tags', 'Like New', 'Excellent', 'Very Good', 'Good', 'Fair'].map(c => (
//                           <option key={c} value={c}>{c}</option>
//                         ))}
//                       </select>
//                       <div style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--grey-mid)', fontSize: 12 }}>▾</div>
//                     </div>
//                   </div>

//                   <Field label="Expected Price (₹)" name="asking_price" value={form.asking_price} onChange={onChange}
//                     type="number" placeholder="Your asking price (optional)" />
//                 </div>
//               </div>

//               {/* Contact Details */}
//               <div style={{ background: '#fff', border: '1px solid #e8e4de', padding: isMobile ? 20 : 28 }}>
//                 <h3 style={sectionTitle}>Your Details</h3>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

//                   <Field label="Full Name *" name="name" value={form.name} onChange={onChange}
//                     placeholder="Your full name" />

//                   <Field label="Phone Number *" name="phone" value={form.phone} onChange={onChange}
//                     type="tel" placeholder="+91 00000 00000" />

//                   <Field label="Email Address" name="email" value={form.email} onChange={onChange}
//                     type="email" placeholder="your@email.com" />

//                   <div>
//                     <label style={labelStyle}>Delivery / Pickup Address</label>
//                     <textarea
//                       name="address"
//                       value={form.address}
//                       onChange={onChange}
//                       rows={3}
//                       placeholder="Street, City, State, PIN code"
//                       style={{ ...inputStyle, resize: 'vertical' }}
//                       onFocus={e => e.target.style.borderColor = 'var(--dark)'}
//                       onBlur={e  => e.target.style.borderColor = '#e5e7eb'}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Notes — only on mobile, placed after contact */}
//               {isMobile && (
//                 <div style={{ background: '#fff', border: '1px solid #e8e4de', padding: 20 }}>
//                   <h3 style={sectionTitle}>Additional Notes</h3>
//                   <textarea
//                     name="description"
//                     value={form.description}
//                     onChange={onChange}
//                     rows={4}
//                     placeholder="Describe the item's history, any signs of wear, accessories included (dust bag, box, cards, receipt), year of purchase, etc."
//                     style={{ ...inputStyle, resize: 'vertical' }}
//                     onFocus={e => e.target.style.borderColor = 'var(--dark)'}
//                     onBlur={e  => e.target.style.borderColor = '#e5e7eb'}
//                   />
//                 </div>
//               )}

//               {/* Submit */}
//               <div style={{ background: '#fff', border: '1px solid #e8e4de', padding: isMobile ? 20 : 28 }}>
//                 <p style={{ fontSize: 11, color: 'var(--grey-mid)', lineHeight: 1.7, marginBottom: 18 }}>
//                   By submitting, you agree that our team may contact you to discuss your item. Submission does not guarantee acceptance. We'll respond within 24–48 hours.
//                 </p>
//                 <button
//                   type="submit"
//                   disabled={saving || uploading}
//                   style={{
//                     width: '100%', padding: '16px 24px',
//                     background: saving || uploading ? 'var(--grey-mid)' : 'var(--dark)',
//                     color: '#fff', border: 'none',
//                     fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase',
//                     fontWeight: 700, cursor: saving || uploading ? 'wait' : 'pointer',
//                     fontFamily: 'var(--font-body)', transition: 'background 0.25s',
//                   }}
//                   onMouseEnter={e => { if (!saving && !uploading) e.currentTarget.style.background = 'var(--gold)'; }}
//                   onMouseLeave={e => { if (!saving && !uploading) e.currentTarget.style.background = 'var(--dark)'; }}>
//                   {saving ? 'Submitting…' : uploading ? 'Uploading Photos…' : 'Submit Consignment Request →'}
//                 </button>
//               </div>

//             </div>
//           </div>
//         </form>
//       </section>

//       {/* ── TRUST FOOTER ── */}
//       <section style={{ background: 'var(--dark)', padding: isMobile ? '40px 20px' : '48px 40px', textAlign: 'center' }}>
//         <div style={{ maxWidth: 700, margin: '0 auto' }}>
//           <div style={{ fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 600, marginBottom: 14 }}>
//             Why Consign with Aurora?
//           </div>
//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)',
//             gap: isMobile ? 24 : 32,
//             marginTop: 8,
//           }}>
//             {[
//               { title: 'Expert Authentication', desc: 'Every item verified by our specialists.' },
//               { title: 'Best Prices',            desc: 'Access our network of verified luxury buyers.' },
//               { title: 'Hassle-Free',             desc: 'We handle everything — you just get paid.' },
//             ].map(item => (
//               <div key={item.title} style={{ textAlign: 'center' }}>
//                 <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#fff', marginBottom: 6, fontFamily: 'var(--font-body)' }}>{item.title}</div>
//                 <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', lineHeight: 1.6 }}>{item.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// /* ── Shared sub-components ── */
// const sectionTitle = {
//   fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase',
//   fontWeight: 700, color: 'var(--dark)', fontFamily: 'var(--font-body)',
//   marginBottom: 18, paddingBottom: 12, borderBottom: '1px solid #ede9e3',
// };
// const labelStyle = {
//   fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase',
//   fontWeight: 700, color: 'var(--grey-dark)', display: 'block', marginBottom: 6,
//   fontFamily: 'var(--font-body)',
// };
// const inputStyle = {
//   width: '100%', border: '1px solid #e5e7eb', padding: '11px 14px',
//   fontSize: 13, color: 'var(--dark)', outline: 'none',
//   fontFamily: 'var(--font-body)', background: '#fafafa',
//   boxSizing: 'border-box', transition: 'border-color 0.2s',
// };

// function Field({ label, name, value, onChange, type = 'text', placeholder = '' }) {
//   return (
//     <div>
//       <label style={labelStyle}>{label}</label>
//       <input
//         type={type} name={name} value={value} onChange={onChange}
//         placeholder={placeholder}
//         style={inputStyle}
//         onFocus={e => e.target.style.borderColor = 'var(--dark)'}
//         onBlur={e  => e.target.style.borderColor = '#e5e7eb'}
//       />
//     </div>
//   );
// }

import { useState, useRef, useEffect } from 'react';
import { uploadImage, submitConsignment } from '../lib/api';
import { imgSrc } from '../lib/env';

/* ─────────────────────────────────────────────
   Responsive hook
───────────────────────────────────────────── */
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);
  return isMobile;
}

/* ─────────────────────────────────────────────
   SellPage
───────────────────────────────────────────── */
export default function SellPage() {
  const isMobile = useIsMobile();

  const [form, setForm] = useState({
    name: '', phone: '', email: '',
    brand: '', item: '', condition: 'Excellent',
    asking_price: '', address: '', description: '',
  });
  const [images,    setImages]    = useState([]);
  const [uploading, setUploading] = useState(false);
  const [saving,    setSaving]    = useState(false);
  const [success,   setSuccess]   = useState(false);
  const [error,     setError]     = useState('');
  const fileRef = useRef();

  function onChange(e) {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  }

  async function handleImages(e) {
    const files     = Array.from(e.target.files || []);
    const remaining = 6 - images.length;
    const toUpload  = files.slice(0, remaining);
    if (!toUpload.length) return;

    setUploading(true);
    try {
      const results = await Promise.all(
        toUpload.map(async (file) => {
          const preview = URL.createObjectURL(file);
          const res     = await uploadImage(file);
          const url     = res.url || res.path || res.file;
          return { preview, url };
        })
      );
      setImages(prev => [...prev, ...results]);
    } catch {
      setError('Image upload failed. Please try again.');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  }

  function removeImage(i) {
    setImages(prev => prev.filter((_, idx) => idx !== i));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!form.name || !form.phone || !form.brand || !form.item) {
      setError('Please fill in Name, Phone, Brand and Item.');
      return;
    }
    if (images.length === 0) {
      setError('Please upload at least one photo of your item.');
      return;
    }
    setSaving(true);
    try {
      const imageUrls = images.map(i => i.url).join(',');
      await submitConsignment({
        name:         form.name,
        phone:        form.phone,
        email:        form.email,
        brand:        form.brand,
        model:        form.item,
        condition:    form.condition,
        asking_price: form.asking_price ? Number(form.asking_price) : null,
        notes: [form.description, form.address ? `Address: ${form.address}` : ''].filter(Boolean).join('\n'),
        images: imageUrls,
      });
      setSuccess(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setSaving(false);
    }
  }

  /* ── SUCCESS STATE ── */
  if (success) return (
    <div className="min-h-[80vh] flex items-center justify-center bg-[#F8F5F0] px-5 py-10">
      <div className="text-center max-w-[480px]">

        {/* Check icon */}
        <div className="w-[72px] h-[72px] rounded-full bg-green-100 border-2 border-green-300 flex items-center justify-center mx-auto mb-6">
          <svg width={32} height={32} fill="none" stroke="#16a34a" strokeWidth={2} viewBox="0 0 24 24">
            <polyline points="20,6 9,17 4,12"/>
          </svg>
        </div>

        <p className="text-[10px] tracking-[0.22em] uppercase text-[var(--gold)] font-semibold font-body mb-3.5">
          Request Received
        </p>
        <h2 className="font-display text-[clamp(28px,4vw,40px)] font-light text-[var(--dark)] tracking-[-0.01em] mb-4">
          Thank You
        </h2>
        <p className="text-[14px] text-[var(--grey-mid)] leading-[1.75] font-light mb-8">
          We've received your consignment request. Our team will review your submission
          and contact you within 24–48 hours with a valuation.
        </p>
        <button
          onClick={() => {
            setSuccess(false);
            setForm({ name:'',phone:'',email:'',brand:'',item:'',condition:'Excellent',asking_price:'',address:'',description:'' });
            setImages([]);
          }}
          className={`aurora-btn-dark ${isMobile ? 'w-full' : 'w-auto'}`}
        >
          Submit Another
        </button>
      </div>
    </div>
  );

  /* ── MAIN FORM ── */
  return (
    <div className="bg-[#F8F5F0] min-h-screen">

      {/* ── HERO ── */}
      <section className="relative overflow-hidden bg-[var(--dark)] text-center px-5 pt-[52px] pb-11 md:px-10 md:pt-[72px] md:pb-[60px]">
        {/* Top gold line */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-10 bg-[var(--gold)] opacity-60" />
        {/* Bottom gold line */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-10 bg-[var(--gold)] opacity-60" />

        <p className="text-[10px] tracking-[0.3em] uppercase text-[var(--gold)] font-semibold font-body mb-5">
          Consignment Service
        </p>
        {/* <h1 className="font-display text-[clamp(32px,6vw,64px)] font-light text-white tracking-[-0.02em] leading-[1.08] mb-[18px]">
          Sell Your Piece
        </h1> */}
         <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(32px,6vw,64px)', fontWeight: 300, color: '#fff', letterSpacing: '-0.02em', lineHeight: 1.08, margin: '0 0 18px' }}>
          Sell Your Piece
        </h1>
        <p className="text-[14px] text-white/45 leading-[1.8] max-w-[480px] mx-auto font-light font-body">
          We authenticate, value and sell your luxury items on your behalf — with full
          transparency and white-glove care at every step.
        </p>
      </section>

      {/* ── HOW IT WORKS ── */}
      {/* <section className="bg-white border-b border-[#ede9e3] px-4 py-8 md:px-10 md:py-12">
        <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-3">
          {[
            { n: '01', title: 'Submit Photos', desc: 'Upload clear images of your item from multiple angles.' },
            { n: '02', title: 'We Evaluate',   desc: 'Our experts authenticate and provide a fair market valuation.' },
            { n: '03', title: 'We Sell',        desc: 'Once listed, we handle photography, sales, and shipping.' },
          ].map((step, i) => (
            <div
              key={step.n}
              className={[
                'py-5 md:py-7 md:px-9',
                !isMobile && i < 2 ? 'md:border-r border-[#ede9e3]' : '',
                isMobile && i < 2  ? 'border-b border-[#ede9e3]'    : '',
              ].join(' ')}
            >
              <div className="font-display text-[36px] font-light text-[var(--gold)] opacity-60 leading-none mb-3">
                {step.n}
              </div>
              <div className="text-[12px] tracking-[0.15em] uppercase font-semibold text-[var(--dark)] font-body mb-2">
                {step.title}
              </div>
              <div className="text-[12px] text-[var(--grey-mid)] leading-[1.7]">
                {step.desc}
              </div>
            </div>
          ))}
        </div>
      </section> */}
            <section style={{ background: '#fff', borderBottom: '1px solid #ede9e3', padding: isMobile ? '32px 16px' : '48px 40px' }}>
        <div style={{
          maxWidth: 900,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)',
          gap: 0,
        }}>
          {[
            { n: '01', title: 'Submit Photos', desc: 'Upload clear images of your item from multiple angles.' },
            { n: '02', title: 'We Evaluate',   desc: 'Our experts authenticate and provide a fair market valuation.' },
            { n: '03', title: 'We Sell',        desc: 'Once listed, we handle photography, sales, and shipping.' },
          ].map((step, i) => (
            <div key={step.n} style={{
              padding: isMobile ? '20px 0' : '28px 36px',
              borderRight: !isMobile && i < 2 ? '1px solid #ede9e3' : 'none',
              borderBottom: isMobile && i < 2 ? '1px solid #ede9e3' : 'none',
            }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 300, color: 'var(--gold)', lineHeight: 1, marginBottom: 12, opacity: 0.6 }}>{step.n}</div>
              <div style={{ fontSize: 12, letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 600, color: 'var(--dark)', fontFamily: 'var(--font-body)', marginBottom: 8 }}>{step.title}</div>
              <div style={{ fontSize: 12, color: 'var(--grey-mid)', lineHeight: 1.7 }}>{step.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── FORM ── */}
      <section className="px-4 pt-8 pb-12 md:px-10 md:pt-[72px] md:pb-20 max-w-[1100px] mx-auto">

        {/* Error */}
        {error && (
          <div className="max-w-[760px] mx-auto mb-7 px-5 py-3.5 bg-red-50 border border-red-200 text-red-600 text-[13px] font-body">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-7">

            {/* ── LEFT: Images + Notes (desktop) ── */}
            <div className="flex flex-col gap-4 md:gap-5">

              {/* Photos */}
              <div className="bg-white border border-[#e8e4de] p-5 md:p-7">
                <h3 className="sell-section-title">
                  Item Photos <span className="text-[var(--red)] font-body">*</span>
                </h3>
                <p className="text-[12px] text-[var(--grey-mid)] mb-5 leading-[1.6]">
                  Upload up to 6 photos. Include front, back, interior, hardware, and any serial number tags.
                </p>

                {/* Upload zone */}
                <div
                  onClick={() => fileRef.current?.click()}
                  className="border-2 border-dashed border-[#d1c5b8] bg-[#faf8f5] cursor-pointer mb-4 flex flex-col items-center justify-center gap-2.5 transition-all duration-200 min-h-[100px] md:min-h-[130px] py-6 px-4 hover:border-[var(--dark)] hover:bg-[#f3f0eb]"
                >
                  <svg width={28} height={28} fill="none" stroke="var(--grey-mid)" strokeWidth={1.4} viewBox="0 0 24 24">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5"/>
                    <polyline points="21,15 16,10 5,21"/>
                  </svg>
                  <div className="text-center">
                    <div className="text-[13px] font-medium text-[var(--dark)] font-body mb-1">
                      {uploading ? 'Uploading…' : 'Tap to upload photos'}
                    </div>
                    <div className="text-[11px] text-[var(--grey-mid)]">
                      JPG or PNG · Up to 6 photos · {images.length}/6 uploaded
                    </div>
                  </div>
                </div>
                <input ref={fileRef} type="file" accept="image/*" multiple hidden onChange={handleImages} />

                {/* Image grid */}
                {images.length > 0 && (
                  <div className="grid grid-cols-3 gap-2">
                    {images.map((img, i) => (
                      <div key={i} className="relative aspect-square overflow-hidden bg-[#e8e4de]">
                        <img
                          src={img.preview || imgSrc(img.url)}
                          alt={`Upload ${i + 1}`}
                          className="w-full h-full object-cover block"
                        />
                        <button
                          type="button"
                          onClick={() => removeImage(i)}
                          className="absolute top-1 right-1 w-[22px] h-[22px] rounded-full bg-black/70 border-none cursor-pointer text-white text-[13px] flex items-center justify-center leading-none"
                        >
                          ×
                        </button>
                        {i === 0 && (
                          <div className="absolute bottom-1 left-1 text-[9px] bg-[var(--gold)] text-white px-1.5 py-[2px] tracking-[0.1em] font-bold">
                            MAIN
                          </div>
                        )}
                      </div>
                    ))}
                    {images.length < 6 && (
                      <div
                        onClick={() => fileRef.current?.click()}
                        className="aspect-square border-2 border-dashed border-[#d1c5b8] bg-[#faf8f5] flex items-center justify-center cursor-pointer text-[24px] text-[var(--grey-mid)] transition-colors duration-200 hover:border-[var(--dark)]"
                      >
                        +
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Notes — desktop only in left column */}
              {!isMobile && (
                <div className="bg-white border border-[#e8e4de] p-7">
                  <h3 className="sell-section-title">Additional Notes</h3>
                  <textarea
                    name="description"
                    value={form.description}
                    onChange={onChange}
                    rows={5}
                    placeholder="Describe the item's history, any signs of wear, accessories included (dust bag, box, cards, receipt), year of purchase, etc."
                    className="aurora-input resize-y focus:border-[var(--dark)]"
                  />
                </div>
              )}
            </div>

            {/* ── RIGHT: Item Details + Contact + Submit ── */}
            <div className="flex flex-col gap-4 md:gap-5">

              {/* Item Details */}
              <div className="bg-white border border-[#e8e4de] p-5 md:p-7">
                <h3 className="sell-section-title">Item Details</h3>
                <div className="flex flex-col gap-3.5">

                  <SellField label="Brand *" name="brand" value={form.brand} onChange={onChange}
                    placeholder="e.g. Louis Vuitton, Chanel, Hermès" />

                  <SellField label="Item / Model *" name="item" value={form.item} onChange={onChange}
                    placeholder="e.g. Neverfull MM, Classic Flap, Birkin 30" />

                  <div>
                    <label className="sell-label">Condition</label>
                    <div className="relative">
                      <select
                        name="condition"
                        value={form.condition}
                        onChange={onChange}
                        className="aurora-input cursor-pointer appearance-none pr-9 focus:border-[var(--dark)]"
                      >
                        {['New with tags','New without tags','Like New','Excellent','Very Good','Good','Fair'].map(c => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                      <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[var(--grey-mid)] text-[12px]">▾</div>
                    </div>
                  </div>

                  <SellField label="Expected Price (₹)" name="asking_price" value={form.asking_price}
                    onChange={onChange} type="number" placeholder="Your asking price (optional)" />
                </div>
              </div>

              {/* Contact Details */}
              <div className="bg-white border border-[#e8e4de] p-5 md:p-7">
                <h3 className="sell-section-title">Your Details</h3>
                <div className="flex flex-col gap-3.5">

                  <SellField label="Full Name *" name="name" value={form.name} onChange={onChange}
                    placeholder="Your full name" />

                  <SellField label="Phone Number *" name="phone" value={form.phone} onChange={onChange}
                    type="tel" placeholder="+91 00000 00000" />

                  <SellField label="Email Address" name="email" value={form.email} onChange={onChange}
                    type="email" placeholder="your@email.com" />

                  <div>
                    <label className="sell-label">Delivery / Pickup Address</label>
                    <textarea
                      name="address"
                      value={form.address}
                      onChange={onChange}
                      rows={3}
                      placeholder="Street, City, State, PIN code"
                      className="aurora-input resize-y focus:border-[var(--dark)]"
                    />
                  </div>
                </div>
              </div>

              {/* Notes — mobile only, after contact */}
              {isMobile && (
                <div className="bg-white border border-[#e8e4de] p-5">
                  <h3 className="sell-section-title">Additional Notes</h3>
                  <textarea
                    name="description"
                    value={form.description}
                    onChange={onChange}
                    rows={4}
                    placeholder="Describe the item's history, any signs of wear, accessories included (dust bag, box, cards, receipt), year of purchase, etc."
                    className="aurora-input resize-y focus:border-[var(--dark)]"
                  />
                </div>
              )}

              {/* Submit */}
              <div className="bg-white border border-[#e8e4de] p-5 md:p-7">
                <p className="text-[11px] text-[var(--grey-mid)] leading-[1.7] mb-[18px] font-body">
                  By submitting, you agree that our team may contact you to discuss your item.
                  Submission does not guarantee acceptance. We'll respond within 24–48 hours.
                </p>
                <button
                  type="submit"
                  disabled={saving || uploading}
                  className="w-full py-4 bg-[var(--dark)] text-white text-[11px] tracking-[0.22em] uppercase font-bold font-body border-none transition-colors duration-200 hover:bg-[var(--gold)] disabled:bg-[var(--grey-mid)] disabled:cursor-wait cursor-pointer"
                >
                  {saving ? 'Submitting…' : uploading ? 'Uploading Photos…' : 'Submit Consignment Request →'}
                </button>
              </div>

            </div>
          </div>
        </form>
      </section>

      {/* ── TRUST FOOTER ── */}
      <section className="bg-[var(--dark)] px-5 py-10 md:px-10 md:py-12 text-center">
        <div className="max-w-[700px] mx-auto">
          <p className="text-[10px] tracking-[0.22em] uppercase text-[var(--gold)] font-semibold mb-3.5 font-body">
            Why Consign with Aurora?
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-2">
            {[
              { title: 'Expert Authentication', desc: 'Every item verified by our specialists.' },
              { title: 'Best Prices',            desc: 'Access our network of verified luxury buyers.' },
              { title: 'Hassle-Free',             desc: 'We handle everything — you just get paid.' },
            ].map(item => (
              <div key={item.title} className="text-center">
                <div className="text-[11px] font-semibold tracking-[0.1em] uppercase text-white mb-1.5 font-body">
                  {item.title}
                </div>
                <div className="text-[12px] text-white/40 leading-[1.6]">
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

/* ─────────────────────────────────────────────
   Shared field component
───────────────────────────────────────────── */
function SellField({ label, name, value, onChange, type = 'text', placeholder = '' }) {
  return (
    <div>
      <label className="sell-label">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="aurora-input focus:border-[var(--dark)]"
      />
    </div>
  );
}